import { RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/lib/auth-context';
import { apiClient } from '@/lib/api-client';
import CacheSettings from '@/components/admin/CacheSettings';

export default function SettingsPreferencesPage() {
  const { isAdmin } = useAuth();

  if (!isAdmin) return <div className="p-8 text-center text-muted-foreground">Nemáte přístup.</div>;

  const handleClearCache = async () => {
    try {
      await apiClient.post<{ ok: boolean }>('/cache/invalidate', {});
      toast.success('Cache vymazána');
    } catch {
      toast.error('Cache se nepodařilo vymazat');
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Nastavení</h1>
          <p className="text-muted-foreground">Aplikační nastavení — cache, integrace</p>
        </div>
        <button
          type="button"
          onClick={handleClearCache}
          className="inline-flex items-center gap-2 rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-9 px-4 cursor-pointer"
        >
          <RefreshCw className="h-4 w-4" />
          Vymazat cache
        </button>
      </div>

      <CacheSettings />
    </div>
  );
}
